<script lang="ts" setup></script>

<template>
  <li>
    <div class="dropdown-header"><slot></slot></div>
  </li>
</template>

<style scoped lang="postcss">
.dropdown-header {
  @apply pointer-events-none px-1 py-1 text-gray-700 font-bold text-xs;
}
</style>
